import { createStore } from 'redux';
import throttle from 'lodash/throttle';
import { loadState } from './local-storage';
import persistState from './persist-state';
import { StateRedux, Action } from './type-redux';

const INITIAL_STATE: StateRedux = {
  aplicacoes: null,
  access: {
    termos: false,
    resetPassword: false,
  },
  realm: {
    nameUsuario: '',
    emailUsuario: '',
    nameRealm: '',
    servicoId: '',
  },
  language: {
    languageSelected: 'pt',
  },
  favorite: {
    ids: [],
  },
  keycloak: undefined,
  toggled: false,
};

// eslint-disable-next-line default-param-last
const userRedux = (state: StateRedux = INITIAL_STATE, action: Action): StateRedux => {
  switch (action.type) {
    case 'APP':
      return {
        ...state,
        aplicacoes: action.aplicacoes,
      };

    case 'USER_REALM':
      return {
        ...state,
        realm: action.realm,
      };

    case 'ACCESS':
      return {
        ...state,
        access: action.access,
      };

    case 'KEYCLOAK':
      return {
        ...state,
        keycloak: action.keycloak,
      };

    case 'TOGGLE':
      return {
        ...state,
        toggled: action.toggled,
      };

    case 'LOGOUT':
      // deleteState();
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');

      return {
        ...INITIAL_STATE,
        favorite: state.favorite,
      };

    case 'LANGUAGE':
      return {
        ...state,
        language: action.language,
      };

    case 'FAVORITE':
      return {
        ...state,
        favorite: action.favorite,
      };
    default:
      return state;
  }
};

const persistedState = loadState();

const store = persistedState
  ? createStore(userRedux, persistedState)
  : createStore(userRedux);

store.subscribe(throttle(persistState(store), 1000));

export default store;
